import { useState } from 'react'
import { routes } from 'Routes'
import { reverse } from 'named-urls'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core'

import useSnackbar from 'hooks/useSnackbar'

import { ConfirmationDialog, Permitted } from 'components'

import constants from 'constants/index'
import * as service from 'service'
import helpers from 'helpers'

const ActionButtons = ({ churn, refresh, setIsLoading }) => {
  const history = useHistory()
  const snackbar = useSnackbar()

  const [openCancelDialog, setOpenCancelDialog] = useState(false)

  const enableCancel = constants.churn.CHURN_STATUS === churn?.status
  const isInitialStatus = constants.churn.STATUSES_INITIAL.includes(
    churn?.status,
  )

  const handleEdit = () => {
    history.push(
      reverse(routes.churns.edit, {
        churnId: churn?.id,
      }),
    )
  }

  const handleView = () => {
    history.push(
      reverse(routes.churns.show, {
        churnId: churn?.id,
      }),
    )
  }

  const handleDestroy = async () => {
    setIsLoading(true)
    try {
      await service.dponet.churns.destroy({ churnId: churn?.id })

      snackbar.open({
        message: 'Churn excluída com sucesso!',
        variant: 'success',
      })

      refresh()
    } catch (error) {
      snackbar.open({
        message: helpers.formatters.errorMessage(
          error?.response?.data?.error ||
            'Erro ao excluir a churn, tente novamente mais tarde!',
        ),
        variant: 'error',
      })
    } finally {
      setIsLoading(false)
    }
  }

  const handleCancel = async () => {
    setIsLoading(true)
    try {
      await service.dponet.churns.cancel({ churnId: churn?.id })

      snackbar.open({
        message: 'Churn cancelada com sucesso!',
        variant: 'success',
      })

      refresh()
    } catch (error) {
      snackbar.open({
        message: helpers.formatters.errorMessage(
          error?.response?.data?.error ||
            'Erro ao cancelar a churn, tente novamente mais tarde!',
        ),
        variant: 'error',
      })
    } finally {
      setIsLoading(false)
      setOpenCancelDialog(false)
    }
  }

  return (
    <>
      <Permitted tag={constants.permissions.CHURNS.SHOW}>
        <Button fullWidth size="small" onClick={handleView}>
          Visualizar
        </Button>
      </Permitted>
      {isInitialStatus && (
        <>
          <Permitted tag={constants.permissions.CHURNS.UPDATE}>
            <Button fullWidth size="small" onClick={handleEdit}>
              Editar
            </Button>
          </Permitted>
          <Permitted tag={constants.permissions.CHURNS.DESTROY}>
            <Button fullWidth size="small" onClick={handleDestroy}>
              Excluir
            </Button>
          </Permitted>
        </>
      )}
      <Permitted tag={constants.permissions.CHURNS.CANCEL}>
        {enableCancel && (
          <Button
            fullWidth
            size="small"
            onClick={() => setOpenCancelDialog(true)}
          >
            Cancelar
          </Button>
        )}
      </Permitted>
      {openCancelDialog && (
        <ConfirmationDialog
          open={openCancelDialog}
          setOpen={setOpenCancelDialog}
          message="Deseja realmente cancelar o churn?"
          alert="Caso algum procedimento já tenha sido executado, como o cancelamento do contrato ou o cancelamento do acesso das empresas, cancelar o churn não vai reativá-los automaticamente. Será necessário reativar manualmente."
          alertColor="warning"
          buttonText="Confirmar"
          cancelButtonText="Voltar"
          actionAcceptButton={handleCancel}
        />
      )}
    </>
  )
}

ActionButtons.propTypes = {
  churn: PropTypes.object,
  refresh: PropTypes.func,
  setIsLoading: PropTypes.func,
}

export default ActionButtons
